/* eslint-disable jsx-a11y/label-has-associated-control */
import Select from 'react-select';
import PropType from 'prop-types';
import { useField } from 'formik';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CustomCategorySelect = (props) => {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(props);
  const {
    brandsList,
    defaultType,
    defaultSub1,
    defaultSub2,
    defaultYear,
    defaultAssisted,
    defaultSize,
    defaultWeight,
    defaultWheels,
    defaultBrand
  } = props;
  const { touched, error } = meta;
  const { setValue } = helpers;

  const types = [
    { label: t('productFormAccessory'), value: 'Accessorio' },
    { label: t('productFormBike'), value: 'Bicicletta' }
  ];

  const [selectedType, setSelectedType] = useState(defaultType);
  const [selectedSub1, setSelectedSub1] = useState(defaultSub1);
  const [selectedSub2, setSelectedSub2] = useState(defaultSub2);
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const [selectedAssisted, setSelectedAssisted] = useState(defaultAssisted);
  const [selectedSize, setSelectedSize] = useState(defaultSize);
  const [selectedWeight, setSelectedWeight] = useState(defaultWeight);
  const [selectedWheels, setSelectedWheels] = useState(defaultWheels);
  const [selectedBrand, setSelectedBrand] = useState(defaultBrand);

  const sizes = [
    { label: 'S', value: 'S' },
    { label: 'M', value: 'M' },
    { label: 'L', value: 'L' },
    { label: 'XL', value: 'XL' }
  ];

  function generateArrayOfYears() {
    const max = new Date().getFullYear();
    const min = 1900;
    const years = [];
    for (let i = max; i >= min; i -= 1) {
      years.push({ label: i.toString(), value: i });
    }
    return years;
  }
  const years = generateArrayOfYears();
  const brands = [{ label: t('productFormNoBrand'), value: 'Non Specificata' }];
  brandsList.map((brand) =>
    brands.push({ value: brand.name, label: brand.name })
  );

  const sub1 = [
    { label: t('productFormStreet'), value: 'Strada' },
    { label: 'Mountain Bike', value: 'Mountain Bike' },
    { label: 'Kids 0-12', value: 'Kids 0-12' },
    { label: 'Specials', value: 'Specials' }
  ];

  const sub2Array = [
    { sub1: 'Strada', label: t('productFormRacing'), value: 'Corsa' },
    { sub1: 'Strada', label: t('productFormTourism'), value: 'Turismo' },
    { sub1: 'Strada', label: 'City', value: 'City' },
    { sub1: 'Mountain Bike', label: 'Cross Country', value: 'Cross Country' },
    { sub1: 'Mountain Bike', label: 'Enduro', value: 'Enduro' },
    { sub1: 'Mountain Bike', label: 'Downhill', value: 'Downhill' },
    { sub1: 'Kids 0-12', label: 'MTB', value: 'MTB' },
    { sub1: 'Kids 0-12', label: t('productFormStreet'), value: 'Strada' },
    { sub1: 'Specials', label: 'BMX', value: 'BMX' },
    { sub1: 'Specials', label: 'Gravel', value: 'Gravel' },
    { sub1: 'Specials', label: 'Fat-Bike', value: 'Fat-Bike' },
    { sub1: 'Specials', label: t('productFormOtherSub'), value: 'Altro' }
  ];
  function parseSub2() {
    return sub2Array
      .filter((data) => data.sub1 === selectedSub1)
      .map((data) => ({ label: data.label, value: data.value }));
  }
  const [sub2, setSub2] = useState(parseSub2);

  const assistedList = [
    { label: t('productFormAssisted'), value: 'Assistita' },
    { label: t('productFormNotAssisted'), value: 'Non Assistita' }
  ];

  const handleChangeType = (value) => {
    setSelectedType(value.value);
  };

  const handleChangeSub1 = (value) => {
    setSelectedSub1(value.value);
  };

  const handleChangeSub2 = (value) => {
    setSelectedSub2(value.value);
  };

  function updateValue() {
    const cat = {
      type: selectedType,
      size: selectedSize,
      sub1: selectedSub1,
      sub2: selectedSub2,
      assisted: selectedAssisted,
      year: selectedYear,
      weight: selectedWeight,
      wheels: selectedWheels,
      brand: selectedBrand
    };
    setValue(cat);
  }

  useEffect(() => {
    if (selectedType === 'Bicicletta') {
      updateValue();
      setSelectedSub1(sub1[0].value);
    } else if (selectedType === 'Accessorio') {
      updateValue();
    }
  }, [selectedType]);

  useEffect(() => {
    const s = parseSub2();
    setSub2(s);
    setSelectedSub2(s[0].value);
  }, [selectedSub1]);

  useEffect(() => {
    updateValue();
  }, [
    selectedSub2,
    selectedAssisted,
    selectedSize,
    selectedYear,
    selectedWheels,
    selectedWeight,
    selectedBrand
  ]);

  return (
    <div className="input-group">
      <label className="label-input">{t('productFormType')}</label>
      {touched && error ? <div className="error">{meta.error}</div> : null}
      <Select
        id={field.name}
        name={field.name}
        options={types}
        value={types[types.findIndex((x) => x.value === selectedType)]}
        onChange={handleChangeType}
      />
      {selectedType === 'Bicicletta' && (
        <>
          <label className="label-input">{t('productFormSub')}</label>
          <Select
            id={field.name}
            name={field.name}
            options={sub1}
            value={sub1[sub1.findIndex((x) => x.value === selectedSub1)]}
            onChange={handleChangeSub1}
          />
          <Select
            id={field.name}
            name={field.name}
            options={sub2}
            value={sub2[sub2.findIndex((x) => x.value === selectedSub2)]}
            onChange={handleChangeSub2}
          />
          <div className="product-form-field">
            <label className="label-input">{t('productFormBrand')}</label>
            <Select
              id={field.name}
              name={field.name}
              options={brands}
              value={brands[brands.findIndex((x) => x.value === selectedBrand)]}
              onChange={(e) => setSelectedBrand(e.value)}
            />
          </div>
          <div className="product-form-field" style={{ marginTop: '1rem' }}>
            <label className="label-input">{t('productFormAssisted')}</label>
            <Select
              id={field.name}
              name={field.name}
              options={assistedList}
              value={
                assistedList[
                  assistedList.findIndex((x) => x.value === selectedAssisted)
                ]
              }
              onChange={(e) => setSelectedAssisted(e.value)}
            />
          </div>
          <div className="product-form-field">
            <label className="label-input">{t('productFormYear')}</label>
            <Select
              id={field.name}
              name={field.name}
              options={years}
              value={{ label: selectedYear, value: selectedYear }}
              onChange={(e) => setSelectedYear(e.value)}
            />
          </div>
          <div className="product-form-field">
            <label className="label-input">{t('productFormSize')}</label>
            <Select
              id={field.name}
              name={field.name}
              options={sizes}
              value={{ label: selectedSize, value: selectedSize }}
              onChange={(e) => setSelectedSize(e.value)}
            />
          </div>
          <br />
          <div className="product-form-field" style={{ marginTop: '10px' }}>
            <label className="label-input">{`${t(
              'productFormWeight'
            )} (Kg)`}</label>
            <input
              type="number"
              id={field.name}
              name={field.name}
              value={selectedWeight}
              onChange={(e) => setSelectedWeight(e.target.value)}
              required
            />
          </div>
          <div className="product-form-field" style={{ marginTop: '10px' }}>
            <label className="label-input">{`${t(
              'productFormWheels'
            )} (")`}</label>
            <input
              type="number"
              id={field.name}
              name={field.name}
              value={selectedWheels}
              onChange={(e) => setSelectedWheels(e.target.value)}
              required
            />
          </div>
        </>
      )}
    </div>
  );
};

CustomCategorySelect.defaultProps = {
  brandsList: [],
  defaultType: 'Bicicletta',
  defaultSub1: 'Strada',
  defaultSub2: 'Corsa',
  defaultSize: 'M',
  defaultBrand: 'Non Specificata',
  defaultAssisted: 'Non Assistita',
  defaultWeight: 8,
  defaultWheels: 20,
  defaultYear: new Date().getFullYear()
};

CustomCategorySelect.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  brandsList: PropType.any,
  defaultType: PropType.string,
  defaultSub1: PropType.string,
  defaultSub2: PropType.string,
  defaultAssisted: PropType.string,
  defaultYear: PropType.number,
  defaultWeight: PropType.number,
  defaultWheels: PropType.number,
  defaultSize: PropType.string,
  defaultBrand: PropType.string
};

export default CustomCategorySelect;
